import { render, staticRenderFns } from "./animalActivities.vue?vue&type=template&id=3dbb59e4"
import script from "./animalActivities.vue?vue&type=script&lang=js"
export * from "./animalActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports